import { Modal as MantineModal } from '@mantine/core';
import styled from 'styled-components';
import { theme } from '../globalStyle/global-styles';

export const Modal = styled(MantineModal)`
  z-index: 999 !important;
  padding: 16px;

  @media (max-width: 768px) {
    .add,
    .cancel {
      width: 100% !important;
    }
  }

  .mantine-Modal-content {
    border-radius: 8px !important;
  }

  .mantine-Modal-body {
    -webkit-overflow-scrolling: touch; /* Enables smooth scrolling on mobile */
    overflow: hidden;
    padding: 0;
  }

  .mantine-Modal-header {
    padding: 16px 24px;
    color: ${theme.colours.blackText};
    font-weight: 600;
    font-size: 14px;
    line-height: 22px;
    background-color: #eeeeee;
    border: none;
    @media (max-width: 767px) {
      padding: 16px !important;
    }
  }
  .button_wrapper {
    border-top: 1px solid #d4d4d4;
  }
`;
